<script lang="ts">
import {defineComponent, type PropType} from "vue";

export default defineComponent({
    name: 'FaceBox',

    props: {
        size: {
            type: Number,
            required: false,
            default: 100,
        },

        face: {
            type: String,
            required: true,
        },

        frame: {
            type: null as unknown as PropType<string | null>,
            required: false,
            default: null,
        },
    },
})
</script>

<template>
    <div
        v-if="frame === null"
        class="box withoutFrame"
        :style="[
            {
                minWidth: `${size}px`,
                width: `${size}px`,
                height: `${size}px`
            },
        ]"
    >
        <img class="face" :src="`/img/page/landing/registration/avatar/${face}/face.png`">
    </div>

    <div
        v-else
        class="box withFrame"
        :style="[
            {
                minWidth: `${size}px`,
                width: `${size}px`,
                height: `${size}px`
            },
        ]"
    >
        <img class="face" :src="`/img/page/landing/registration/avatar/${face}/face.png`">

        <img
            v-if="frame"
            class="frame"
            :src="`/img/faceframes/${frame}`"
        >
    </div>
</template>

<style scoped>
.box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.box.withoutFrame {
    //border: 1px solid rgba(255, 255, 255, 0.3);
    //border-radius: 5px;
    overflow: hidden;
}

.face {
    //background-color: black;
}

.box.withoutFrame .face {
    width: 100%;
    height: 100%;
}

.box.withFrame .face {
    margin: 10%;
    width: 80%;
    height: 80%;
}

.frame {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
}

</style>
